import React from "react";
import Styles from "./FileUploadImageErrorModal.module.scss";
import { Modal, Space, Text, Button } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import { ArrowLeftOutlined } from "@ant-design/icons";

const FileUploadErrorModalStyles = {
  changed: {
    fontSize: variables.fontSizeXlarge,
    fontWeight: variables.fontWeightBold,
  },
  changedSuccess: {
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    textAlign: variables.alignCenter,
    display: variables.dBlock,
  },
  button: {
    border: `1px solid ${variables.grey4}`,
    fontSize: variables.fontSizeSmall,
    fontWeight: variables.fontWeightNormal,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
  },
  modalContent: { width: variables.fullWidth },
  modalMaskStyle: {
    backdropFilter: variables.highBlur,
    background: variables.blurBackground,
  },
};

export default function FileUploadImageErrorModal({
  open,
  header,
  description,
  onClose,
  buttonText,
  iconSrc,
}) {
  return (
    <Modal
      maskClosable={false}
      maskStyle={FileUploadErrorModalStyles.modalMaskStyle}
      className={Styles["edged-modal"]}
      centered
      open={open}
      closable={false}
      footer={null}
      width={400}
    >
      <Space
        direction="vertical"
        align="center"
        style={FileUploadErrorModalStyles.modalContent}
      >
        <img src={iconSrc} alt="pass-changed" />
        <Text style={FileUploadErrorModalStyles.changed}>{header}</Text>
        <Text style={FileUploadErrorModalStyles.changedSuccess}>
          {description}
        </Text>
        <Button
          onClick={onClose}
          type="dashed"
          style={FileUploadErrorModalStyles.button}
          icon={<ArrowLeftOutlined />}
        >
          {buttonText}
        </Button>
      </Space>
    </Modal>
  );
}
